import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import LoginPage from "@/pages/login/page";
import DashboardPage from "@/pages/dashboard/page";
import VentasPage from "@/pages/ventas/page";
import ProductosPage from "@/pages/productos/page";
import ValuacionCppPage from "@/pages/valuacion-cpp/page";
import ReportesPage from "@/pages/reportes/page";
import HistorialVentasPage from "@/pages/historial-ventas/page";
import UsuariosPage from "@/pages/usuarios/page";
import ConfiguracionPage from "@/pages/configuracion/page";
import { ProtectedRoute, AdminRoute } from "@/components/feature/ProtectedRoute";

const routes: RouteObject[] = [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <DashboardPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/ventas",
    element: (
      <ProtectedRoute>
        <VentasPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/productos",
    element: (
      <ProtectedRoute>
        <ProductosPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/movimientos-inventario",
    element: (
      <ProtectedRoute>
        <AdminRoute>
          <ValuacionCppPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/reportes",
    element: (
      <ProtectedRoute>
        <ReportesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/historial-ventas",
    element: (
      <ProtectedRoute>
        <HistorialVentasPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/usuarios",
    element: (
      <ProtectedRoute>
        <AdminRoute>
          <UsuariosPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/configuracion",
    element: (
      <ProtectedRoute>
        <AdminRoute>
          <ConfiguracionPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/",
    element: <LoginPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;